export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7676.6ab756c7.jpg";